import { c as _c } from "react/compiler-runtime";
import type { ApiNodeDataExternalApi, NodeDataUpdateExternalApi } from '@onefootprint/request-types/dashboard';
import { Divider, Shimmer } from '@onefootprint/ui';
import type { NodeProps } from '@/playbook-builder/playbook-builder.types';
import useStore from '../../hooks/use-store';
import BaseNode from '../base-node';
import VendorIntegrationContent from './components/vendor-integration-content';
import { VENDOR_INTEGRATION_FORM_ID } from './components/vendor-integration-form';
import useVendorIntegrations from './hooks/use-vendor-integrations';
type VendorIntegrationNodeProps = NodeProps<ApiNodeDataExternalApi> & {
  onSubmit?: (data: NodeDataUpdateExternalApi) => void; // For storybook testing
};
export const VendorIntegrationNode = t0 => {
  const $ = _c(17);
  let node;
  let onSubmit;
  if ($[0] !== t0) {
    ({
      onSubmit,
      ...node
    } = t0);
    $[0] = t0;
    $[1] = node;
    $[2] = onSubmit;
  } else {
    node = $[1];
    onSubmit = $[2];
  }
  const {
    data: t1
  } = useStore();
  const {
    canEdit,
    traceEntries
  } = t1;
  const {
    integrations,
    isLoading
  } = useVendorIntegrations();
  let t2;
  if ($[3] !== node.id || $[4] !== traceEntries) {
    t2 = traceEntries?.find(entry => node.id === entry.decisionNodeId);
    $[3] = node.id;
    $[4] = traceEntries;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const traceEntry = t2;
  let t3;
  if ($[6] !== canEdit || $[7] !== integrations || $[8] !== isLoading || $[9] !== node || $[10] !== onSubmit || $[11] !== traceEntry) {
    t3 = {
      size: "lg",
      form: VENDOR_INTEGRATION_FORM_ID,
      render: t4 => {
        const {
          mutation
        } = t4;
        return isLoading ? <Loading /> : <VendorIntegrationContent node={node} mutation={mutation} canEdit={canEdit} traceEntry={traceEntry} integrations={integrations} onSubmit={onSubmit} />;
      }
    };
    $[6] = canEdit;
    $[7] = integrations;
    $[8] = isLoading;
    $[9] = node;
    $[10] = onSubmit;
    $[11] = traceEntry;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  let t4;
  if ($[13] !== node.data || $[14] !== node.id || $[15] !== t3) {
    t4 = <BaseNode nodeId={node.id} data={node.data} sidebar={t3} />;
    $[13] = node.data;
    $[14] = node.id;
    $[15] = t3;
    $[16] = t4;
  } else {
    t4 = $[16];
  }
  return t4;
};
const Loading = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="flex flex-col gap-4 pb-4"><div className="flex flex-row justify-between w-full items-center"><Shimmer width="76px" height="20px" /><Shimmer width="50%" height="32px" /></div><Divider /><Shimmer width="100%" height="250px" /><Shimmer width="100%" height="424px" /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export default VendorIntegrationNode;